import {fetchJSONByGet, fetchJSONByPost, fetchJSONByPut, fetchJSONByDel} from './index.js'
// 查询合作伙伴列表
export const partnerPageApi = (params) => fetchJSONByGet('/admin-api/ins/company/cargoAgent/page', params)
// 查看合作伙伴
export const partnerDetailApi = (id) => fetchJSONByGet(`/admin-api/ins/company/cargoAgent/${id}`)
// 查询服务费率等级列表
export const rateLevelPageApi = (params) => fetchJSONByGet('/admin-api/ins/rate-level/page', params)
// 删除服务费等级
export const delRateLevelApi = (params) => fetchJSONByDel('/admin-api/ins/rate-level/delete', {params})
// 创建服务费等级
export const createLevelApi = (body) => fetchJSONByPost('/admin-api/ins/rate-level/create', body)
// 更新服务费等级
export const updateLevelApi = (body) => fetchJSONByPut('/admin-api/ins/rate-level/update', body)
// 设置等级 
export const setLevelApi = (body) => fetchJSONByPost('/admin-api/ins/company/partner-level/create', body)
// 拒绝
export const rejectRegisterApi = (id, body) => fetchJSONByPost(`/admin-api/ins/company/cargo/update/${id}`, body)
// 
export const orderReportApi = (params) => fetchJSONByGet('/admin-api/ins/company/order/report', params)